/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { HttpClient, RequestParams } from "./http-client";

export class DocumentDrafting<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * @description Obtiene las plantillas de documentos jurídicos disponibles
   *
   * @tags documents
   * @name GetDocumentTemplatesDocumentDraftingTemplatesGet
   * @summary Plantillas Disponibles
   * @request GET:/document-drafting/templates
   */
  getDocumentTemplatesDocumentDraftingTemplatesGet = (params: RequestParams = {}) =>
    this.request<Record<string, string[]>, any>({
      path: `/document-drafting/templates`,
      method: "GET",
      format: "json",
      ...params,
    });
}
